import React, {useState} from 'react';
import {View, Text, StyleSheet} from 'react-native';
import TitleBlock from '../../components/TitleBlock';
import Themes from '../../themes';
import FormTMCWeb from '../../form/FormTMC/web';

const SimuTMC = ({navigation}) => {
  const [terv, setTERV] = useState(0);
  const [tmc, setTMC] = useState(0);
  const [total, setTotal] = useState(0);

  const form = (
    <View style={[styles.scene]}>
      <FormTMCWeb setTERV={setTERV} setTMC={setTMC} setTotal={setTotal} />
    </View>
  );

  const results = (
    <View style={[styles.scene]}>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>
          Taxe d'environnement pour le recyclage des véhicules (TERV)
        </Text>
        <Text style={[styles.result]}>{terv}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>Taxe de mise en circulation (TMC)</Text>
        <Text style={[styles.result]}>{tmc}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>Total à payer</Text>
        <Text style={[styles.result]}>{total}</Text>
      </View>
    </View>
  );

  return (
    <>
      <TitleBlock
        bgColor={Themes.colors.lightTeal}
        textColor={Themes.colors.mediumBlue}
        image={require('../../assets/home-icon-money.png')}>
        Calcul de la taxe de mise en circulation
      </TitleBlock>
      {form}
      {results}
    </>
  );
};

const styles = StyleSheet.create({
  scene: {
    flex: 1,
    padding: 20,
  },
  resultItem: {
    flexDirection: 'row',
    paddingVertical: 3,
    borderBottomWidth: 3,
    borderBottomColor: Themes.colors.lightBlue,
    borderStyle: 'dashed',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    flex: 1,
    flexGrow: 2,
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: Themes.colors.lightBlue,
  },
  result: {
    flex: 1,
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: Themes.colors.lightBlue,
    textAlign: 'right',
  },
});

export default SimuTMC;
